import src from "IMAGE";
export default { src, width: 127, height: 42, blurWidth: 0, blurHeight: 0};
